module.exports = __webpack_public_path__ + "static/media/a.4a9d18e5.png";